module.exports = __webpack_public_path__ + "static/product-teams-8ec755b5fe0de8ab433bc3c3c30bf2e5.svg";